module.exports = __webpack_public_path__ + "img/05.d92be257.png";